/* eslint-disable */
import { grey } from '@material-ui/core/colors';

/**
 * Create styles for `<OrderDetailsHeader />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderDetailsHeader />` styles
 */
const orderDetailsHeaderStyles = ({ theme }) => ({
  title: {
    marginRight: theme.spacing(1),
    textTransform: `none`,
  },
  editOrderContent: {
    paddingRight: 0,
    paddingLeft: 0,
  },
  editOrderTitle: {
    borderBottom: `1px solid ${theme.palette.grey[`300`]}`,
    padding: theme.spacing(1) * 1.1,
    paddingLeft: theme.spacing(1) * 1.4,
    paddingRight: theme.spacing(1) * 3,
  },
  optionsButton: {
    marginRight: theme.spacing(1) * 2,
  },
  icons: {
    paddingLeft: theme.spacing(1) * 3,
  },
  customIcon: {
    display: `inline-block`,
    height: theme.spacing(1) * 3,
    width: theme.spacing(1) * 3,
  },
  toolbar: {
    borderBottom: `1px solid ${grey[300]}`,
    backgroundColor: `#fff`,
    paddingBottom: 18,
    paddingLeft: theme.spacing(1),
    marginTop: 24,
    position: `relative`,
    zIndex: 1,
    [theme.breakpoints.down(`sm`)]: {
      paddingBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    [theme.breakpoints.down(`xs`)]: {
      paddingBottom: 4,
      marginTop: 4,
    },
  },
  statusContainer: {
    [theme.breakpoints.down(`xs`)]: {
      top: theme.spacing(7),
      position: `absolute`,
      zIndex: 10,
      width: `100%`,
      backgroundColor: `#fff`,
      left: 0,
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
      borderBottom: `1px solid ${grey[300]}`,
    },
  },
  pendingChipWrapper: {
    paddingLeft: theme.spacing(1),
  },
  dialogWrapper: {
    zIndex: 1000000,
  },
});

export default orderDetailsHeaderStyles;
